import server from "../../../../server";
import { IDocument } from "../type/document.types";


export async function fetchDocument(docId: string): Promise<IDocument> {
    const document = await server.document.get(docId);
    return {
        id: document.id,
        name: document.originalFileName,
        contentType: document.contentType,
    }
}

